import $ from 'jquery';
import {useEffect,useRef} from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes  } from 'react-router-dom';

import Index from './pages/index';
import Blogs_Landing_With_Child from './pages/blogs_landing_with_child';
import Contact_Us from './pages/contact_us';
import Member_Reg from './pages/member_reg';
import Login_New  from './pages/login_new';
import My_Profile from './user_pages/my_profile';
import Dashboard from './user_pages/dashboard';
import View_All_Request from './user_pages/view_all_request';
import Deduction_Summary from './user_pages/deduction_summary';
import Purchase_History from './user_pages/purchase_history';
import Intrested_Member from './user_pages/intrested_member';
import My_Biodata from './user_pages/my_biodata';
import Share_BioData from './user_pages/share_biodata';
//import  Test_Index from './pages/test_index';

window.jQuery = $;
window.$ = $;
global.jQuery = $;
let jQuery=$;
function App() {
  const hasRun = useRef(false);
useEffect(()=>{
 
  if (hasRun.current) return; // Prevent running twice
  hasRun.current = true;



},[])


  return (
    <Router><Routes >
    {/* <Route exact path="/contactus" component={ContactUs}/> */}
    {/* <Route path="test" element={<Test_Index/>}/> */}

    <Route path="/taxation_services" element={<Blogs_Landing_With_Child/>}/>
    <Route path="/taxation_services/:name" element={<Blogs_Landing_With_Child/>}/>

    <Route path="/auditing_and_financial_assistance" element={<Blogs_Landing_With_Child/>} />
    <Route path="/auditing_and_financial_assistance/:name" element={<Blogs_Landing_With_Child/>} />
    
    <Route path="/fund_sourcing" element={<Blogs_Landing_With_Child/>} />
    <Route path="/fund_sourcing/:name" element={<Blogs_Landing_With_Child/>} />

    <Route path="/business_management_services" element={<Blogs_Landing_With_Child/>} />
    <Route path="/business_management_services/:name" element={<Blogs_Landing_With_Child/>} />

    <Route path="/business_registration_services" element={<Blogs_Landing_With_Child/>} />
    <Route path="/business_registration_services/:name" element={<Blogs_Landing_With_Child/>} />
    
    <Route path="/legal_assistance" element={<Blogs_Landing_With_Child/>} />
    <Route path="/legal_assistance/:name" element={<Blogs_Landing_With_Child/>} />

    <Route path="/startup_assistance" element={<Blogs_Landing_With_Child/>} />
    <Route path="/startup_assistance/:name" element={<Blogs_Landing_With_Child/>} />
    
    <Route path="/services" element={<Blogs_Landing_With_Child/>} />
    <Route path="/services/:name" element={<Blogs_Landing_With_Child/>} />

    <Route path="/articles" element={<Blogs_Landing_With_Child/>} />
    <Route path="/articles/:name" element={<Blogs_Landing_With_Child/>} />

    <Route path="/blogs/:name" element={<Blogs_Landing_With_Child/>}/>
    <Route path="/blog/:name" element={<Blogs_Landing_With_Child/>}/>
    <Route path="/committee/:name" element={<Blogs_Landing_With_Child/>}/>
    <Route path="/community/:name" element={<Blogs_Landing_With_Child/>}/>

    <Route path="/contactus" element={<Contact_Us/>}/>
    <Route path="/contact_us" element={<Contact_Us/>}/>
    <Route path="/member_registration" element={<Member_Reg/>}/>
    <Route path="/login" element={<Login_New/>}/>

    <Route path="/my_profile" element={<My_Profile/>} />
    <Route path="/share_profile/:name" element={<Share_BioData/>}/>
    <Route path="/dashboard" element={<Dashboard/>} />
    <Route path="/view_all_request" element={<View_All_Request/>}/>
    <Route path="/deduction_summary" element={<Deduction_Summary/>}/>
    <Route path="/purchase_history" element={<Purchase_History/>}/>
    <Route path="/intrested_member" element={<Intrested_Member/>}/>
    <Route path='/my_biodata' element={<My_Biodata/>}/>

    <Route  path="/*" element={<Index/>}/>
    
  
</Routes ></Router>
  );
}

export default App;
